export default {
  models_pending: false,
  models: [],
  collaborateurs_pending: false,
  collaborateurs: []
}
